import { MINUTES_TO_MS, SECONDS_TO_MS } from "@pm2/compat";

export function formatTime(timeInMs: number | undefined): string {
  if (typeof timeInMs !== "number") {
    return "";
  }

  const minutes = Math.floor(timeInMs / MINUTES_TO_MS);
  const seconds = Math.round(timeInMs / SECONDS_TO_MS) % 60;

  return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
    2,
    "0",
  )}`;
}
